// https://date-fns.org/v4.1.0/docs/format
export const DATE_FORMAT = "MM/dd/yyyy hh:mm a";
